import {
  ConnectionError,
  NotFoundError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../app/errors';

const accountDetailsUrl = `${api_config.bet_tracker_api}/account/`;

// eslint-disable-next-line import/prefer-default-export
export const getAccountDetails = () => (
  fetch(accountDetailsUrl, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 400:
        case 403:
        case 404: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => response.json())
);

const balanceUrl = `${api_config.bet_tracker_api}/wallet/online/`;

export const getAccountBalance = () => (
  fetch(balanceUrl, {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 200: {
          return response;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => response.json())
);
